export default [
  {
    id: 5,
    first_name: "یاسین",
    last_name: "سعیدی",
    email: "yasin.saedi.test@gmail.com",
    mobile: "09129871234",
    wallet: 560000,
    registered_at: "۱۴۰۱/۱۰/۰۵ ۲۰:۳۴:۵۲",
    last_login_in: "۱۴۰۱/۱۰/۰۸ ۱۸:۱۳:۴۹",
    type: 1,
    national_code: 104023492,
    identity_number: 52330505,
    phone: "02112345678",
    state: "تهران",
    city: "تهران",
    town: "تهران",
    postal_code: "1349675637",
    address: "تهران خ رودکی",
    description: "اینجانب در زمینه تولید مجله های تبلیغاتی فعالیت می کنم",
  },
  {
    id: 4,
    first_name: "مرجان",
    last_name: "رسولی",
    email: "marjan.rasoli.test@gmail.com",
    mobile: "۰۹۳۶ ۹۵۲ ۷۴ ۰۱",
    mobile: "09369527401",
    wallet: 250000,
    registered_at: "۱۴۰۱/۱۰/۰۷ ۲۰:۲۵:۵۲",
    last_login_in: "۱۴۰۱/۱۰/۰۹ ۱۸:۱۹:۴۹",
    type: 1,
    national_code: 104025292,
    identity_number: 52370505,
    phone: "02112345679",
    state: "تهران",
    city: "تهران",
    town: "تهران",
    postal_code: "1349065637",
    address: "تهران خ میرداماد",
    description: "اینجانب یک آژانس تبلیغاتی دارم",
  },
];
